module.exports = __webpack_public_path__ + "static/media/ubicacion-cruz-290.efe369a4.jpg";